import { Box, Container, Heading, Image, ListItem, SimpleGrid, Text, UnorderedList, useBreakpointValue } from '@chakra-ui/react'
import React, { useRef } from 'react'
import education from '../../constants/education'
import BgEducation from '../../assets/images/bg-education.jpg'
import IconEducation from '../../assets/images/education.gif'
import { motion, useScroll, useTransform } from 'framer-motion'

const Educations = () => {
  const container = useRef()

  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start end', 'end start']
  })

  const headerMotion = useBreakpointValue({
    base: 0,
    md: useTransform(scrollYProgress, [0, 1], [-70, 70])
  })

  const educationMotion = useBreakpointValue({
    base: 0,
    md: useTransform(scrollYProgress, [0, 1], [-20, 20])
  })

  const imgMotion = useBreakpointValue({
    base: 0,
    md: useTransform(scrollYProgress, [0, 1], [-250, 250])
  })

  return (
    <Box
      ref={container}
      py={{
        base: 12,
        md: 16,
        lg: 24
      }}
      backgroundColor={'gray.100'}
      backgroundImage={BgEducation}
      bgSize={'cover'}
      bgPosition={'center'}
      bgAttachment={'fixed'}>
      <Container maxW={'container.xl'}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <Box>
            <Box
              style={{
                y: headerMotion
              }}
              as={motion.div}>
              <Heading
                fontSize={{
                  base: '1.25rem',
                  md: '2rem'
                }}
                textAlign={{
                  base: 'center'
                }}
                mb={{
                  base: 6,
                  md: 12
                }}
                color={'white'}>
                {education.title}
              </Heading>
            </Box>

            <Box
              style={{
                y: educationMotion
              }}
              as={motion.div}>
              {education.data.map((item, i) => {
                return (
                  <Box key={i}>
                    <Box mb={6} color={'white'}>
                      <Heading
                        fontSize={{
                          base: '1.1rem',
                          lg: '1.5rem'
                        }}
                        mb={{
                          base: 1
                        }}>
                        {item.nama}
                      </Heading>
                      <Text
                        fontSize={{
                          base: '.85rem',
                          lg: '1rem'
                        }}>
                        {item.study} | {item.date.start} - {item.date.end}
                      </Text>
                    </Box>
                    <Box>
                      <UnorderedList
                        fontSize={{
                          base: '1rem',
                          lg: '1rem'
                        }}
                        color={'white'}
                        fontWeight={'500'}>
                        {item.activities.map((activity, i) => (
                          <ListItem key={i}>{activity}</ListItem>
                        ))}
                      </UnorderedList>
                    </Box>
                  </Box>
                )
              })}
            </Box>
          </Box>

          <Box
            style={{
              y: imgMotion
            }}
            as={motion.div}
            w={{
              base: 'auto'
            }}
            h={{
              base: 350
            }}
            display={{
              base: 'none',
              md: 'flex'
            }}
            justifyContent={'center'}
            alignItems={'center'}>
            <Image
              src={IconEducation}
              w={{
                base: '100%'
              }}
              h={'100%'}
              objectFit={'contain'}
              alt="Education Image"
            />
          </Box>
        </SimpleGrid>
      </Container>
    </Box>
  )
}

export default Educations
